"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var react_2 = require("@emotion/react");
var VideoField = function (_a) {
    var videoData = _a.videoData;
    var videoThumbnailSrc = videoData.data.thumbnail
        ? (0, react_1.useBreakpointValue)({
            base: videoData.data.thumbnail.m,
            md: videoData.data.thumbnail.l,
        })
        : undefined;
    return ((0, jsx_runtime_1.jsxs)(react_1.Box, __assign({ width: "100%", css: videoData.style, className: "" + (videoData.class ? videoData.class : "") }, { children: [(0, jsx_runtime_1.jsx)("video", { css: videoStyle, src: "" + videoData.data.video, poster: videoThumbnailSrc, controls: true }, void 0), videoData.data.caption && ((0, jsx_runtime_1.jsx)(react_1.Box, __assign({ mt: "1rem" }, { children: videoData.data.caption }), void 0))] }), void 0));
};
exports.VideoField = VideoField;
var videoStyle = (0, react_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var templateObject_1;
